import Cookies from "js-cookie";
import React, { SetStateAction, useEffect, useState } from "react";
import { toast } from "react-toastify";
import AppointmentCard from "src/Components/Cards/AppointmentCard";
import DoctorWhislistCard from "src/Components/WebsiteComponents/HomePage/Cards/DoctorWhislistCard";
import httpRequest from "src/helpers/httpRequest";
import { customer, doctorMode } from "src/lib/constans";
import {
  IAppintentType,
  IAppointmentItems,
  IDropDownArray,
  IqueryParams,
} from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { capitalize } from "@mui/material";
import moment from "moment";
import PaginationWrapper from "src/Components/WebsiteComponents/PaginationWrapper";
import { Dispatch } from "@reduxjs/toolkit";
import NoItemUI from "src/Components/NoItemUI";
import { useNavigate } from "react-router-dom";

interface IMyAppointmentResponse {
  documents: IAppintentType[];
  paginated: IPaginated;
}

interface IProps {
  setData: any;
  data: IAppintentType[];
  setIsLoader: any;
  queryParams: IqueryParams;
  setPaginated: any;
  isLoader: boolean;
  onClose: () => void;
}

const OnlineAppointmentsSection: React.FC<IProps> = ({
  setData,
  data,
  setIsLoader,
  queryParams,
  setPaginated,
  isLoader,
  onClose,
}) => {
  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<IMyAppointmentResponse>({
      path: `/appoiment/booking?${qs.stringify(queryParams)}`,
    });
    if (res) {
      const { documents = [], paginated } = res;
      let data = documents.map((item: any) => {
        let dat: IAppintentType = {
          id: item?._id,
          name: capitalize(item?.firstName) + " " + capitalize(item?.lastName),
          status: item?.status,
          rating: 4,
          fee: Number(item?.fees),
          patientName: item?.patientName,
          date: moment(item?.appoinmentDate).format("DD-MM-YYYY"),
          time: (() => {
            const start = item?.startTime
              ? moment(item.startTime, "HH:mm")
              : null;
            const end = item?.endTime ? moment(item.endTime, "HH:mm") : null;

            if (start && end && start.isValid() && end.isValid()) {
              return `${start.format("h:mm A")} - ${end.format("h:mm A")}`;
            } else if (start && start.isValid()) {
              return start.format("h:mm A");
            } else if (end && end.isValid()) {
              return end.format("h:mm A");
            } else {
              return "";
            }
          })(),
          image: item?.image,
          specialty: item?.speicalizationData,
          qualification: "M.B.B.S , F.C.P.S",
          customerNotified: item?.customerNotified,
        };
        return dat;
      });
      setData((prev: IAppintentType[]) => [...prev, ...data]);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" }); // Show error toast if API call fails
    }
    setIsLoader(false);
  };

  useEffect(() => {
    fetch();
  }, [queryParams]);

  const navigate = useNavigate();

  return (
    <>
      {data.map((doctor, index) => (
        <AppointmentCard
          id={`view-details-${index}`}
          key={doctor.id}
          doctor={doctor}
          type="online"
          onViewDetails={() => {
            navigate(`/appointment/${doctor.id}/view`);
            onClose();
          }}
          unread={doctor?.customerNotified ? 0 : 1}
        />
      ))}
    </>
  );
};

export default OnlineAppointmentsSection;
